import mixpanel from 'mixpanel-browser';
import { useCallback } from 'react';
import { MODE } from '../../constants/config';
import { useAppSelector } from '../../store/hooks';

type ReturnType = {
  trackEvent: (name: string) => void;
  isMixPanelInitialized: boolean;
};

export const useMixPanel = (): ReturnType => {
  const isMixpanelInitialized = useAppSelector(
    (state) => state.global.isMixpanelInitialized
  );

  const trackEvent = useCallback(
    (eventName: string) => {
      const checkedEventName = eventName.length ? eventName : '';

      if (isMixpanelInitialized) {
        try {
          mixpanel?.track(checkedEventName);
        } catch (error) {
          // catch crash if mixpanel is not initialized
          if (MODE !== 'prod') {
            // eslint-disable-next-line no-console
            console.error(error);
          }
        }
      }
    },
    [isMixpanelInitialized]
  );

  return {
    trackEvent,
    isMixPanelInitialized: isMixpanelInitialized,
  };
};
